import React, { useState } from "react";
import { Spin, message } from "antd";
import { useHistory } from "react-router-dom";
import RoleLoginForm from "../../components/RoleLoginForm/RoleLoginForm";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG, SESSION_TOKEN } from "../../constants/constants";
import { routes } from "../../routes/Routes";
import { applyFirmAdminSession } from "../../utils/firmAdminRedirect";

const RoleLoginClient = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinishHandle = async (values) => {
        const reqObj = {
            Email: values.email,
            Password: values.password,
            IsFirmAdmin: false,
        };
        setLoading(true);
        try {
            const res = await _NewapplicationService.userLogin(reqObj);
            if (res.data.IsSuccess) {
                if (res?.data?.Obj?.Is_Subscription_Corporate_FirmAdminUser) {
                    applyFirmAdminSession(res.data.Obj, values.email, values.password, history);
                    return;
                }
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj?.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("IsFirmAdminFlag", res?.data?.Obj?.IsFirmAdmin);
                localStorage.setItem("HasOtherRoleAssociation", res?.data?.Obj?.HasOtherRoleAssociation);
                localStorage.setItem("Id", res?.data?.Obj?.Id);
                localStorage.setItem("BankAdminId", res?.data?.Obj?.BankAdminId);
                localStorage.setItem("BankerId", res?.data?.Obj?.BankerId);
                localStorage.setItem("ApplicationId", res?.data?.Obj?.Id);
                localStorage.setItem("RoleId", res?.data?.Obj?.RoleId);
                localStorage.setItem("Role", res?.data?.Obj?.Role);
                localStorage.setItem("FirmAdmin",JSON.stringify(res?.data?.Obj?.IsFirmAdmin ?? false));
                localStorage.setItem("loginEmail", reqObj.Email);
                localStorage.setItem("SponserIdForFirmLogin", res?.data?.Obj?.SponserId);
                localStorage.setItem("IsKey", reqObj.Password);
                localStorage.setItem("IsSwitchFirmAdmin", JSON.stringify(false));
                localStorage.setItem("IsFromNewClientLoginPage", JSON.stringify(true));
                localStorage.setItem("IsFromNewLoginPage", routes.roleLoginClient.path);
                history.push({ pathname: routes.myApplications.path, state: { email: values.email } });
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const forgotPassword = () => {
        history.push({ pathname: routes.forgotUserLoginPasswordSendOTP.path, state: { fromNewLoginPage: routes.roleLoginClient.path } });
    };

    return (
        <Spin spinning={loading}>
            <RoleLoginForm
                title="Client Portal"
                onFinishHandle={onFinishHandle}
                forgotPassword={forgotPassword}
                isNewAccountCreateFlag={false}
                onBack={() => history.push(routes.loginNewPage.path)}
                hideSSOButton={true}
            />
        </Spin>
    );
};

export default RoleLoginClient;
